import styles from "./Pagination.module.css";
import Search, { SearchFilters, SearchOptions } from "./Search";
import { MouseEvent } from "react";

interface PaginationProps {
    currentPageNo?: number;
    lastPageNo?: number;
    onPageChanged?: (current: number) => void;

    searchFilters?: SearchFilters[];
    doSearch?: (searchOptions: SearchOptions) => void;
}

const Pagination = (props: PaginationProps) => {
    /**
     * 페이지 버튼 클릭 이벤트
     * @param event
     */

    const handlePageClick = (event: MouseEvent<HTMLElement>) => {
        const value = event.currentTarget.getAttribute("data-dest");

        if (value) {
            const number = parseInt(value);
            if (props.onPageChanged !== undefined) {
                props.onPageChanged(number);
            }
        }
    };

    /**
     * 페이지 버튼 DOM 생성 함수
     * @param current 현재 페이지 번호
     * @param end 마지막 페이지 번호
     *
     * @return 페이지네이션 JSX.Element[]
     */
    const generatePages = (current: number, end: number) => {
        const DOM: JSX.Element[] = [];
        const pageStart = current - 2 > 0 ? current - 2 : 1;

        // DOM.push(<div className={'pageButton shortcut'} key={'page_first'} style={{ backgroundImage: 'url(images/paging/first.png)' }} onClick={handlePageClick} data-dest={1}></div>)

        if (pageStart !== 1 && end > 5) {
            DOM.push(
                <div
                    className={`${styles.pageButton} ${styles.shortcut}`}
                    key={"page_prev"}
                    style={{ backgroundImage: "url(../../img/prev.png)" }}
                    onClick={handlePageClick}
                    data-dest={current - 5 >= 1 ? current - 5 : 1}
                ></div>
            );
        }

        for (let i = end > 5 && pageStart >= end - 4 ? end - 4 : end > 5 ? pageStart : 1; i <= pageStart + 4 && i <= end; i++) {
            DOM.push(
                <div className={i === current ? `${styles.pageButton} ${styles.active}` : styles.pageButton} key={`page_${i}`} onClick={handlePageClick} data-dest={i}>
                    {i}
                </div>
            );
        }

        if (pageStart + 5 <= end) {
            DOM.push(
                <div
                    className={`${styles.pageButton} ${styles.shortcut}`}
                    key={"page_next"}
                    style={{ backgroundImage: "url(../../img/next.png)" }}
                    onClick={handlePageClick}
                    data-dest={current + 5 <= end ? current + 5 : end}
                ></div>
            );
        }

        // DOM.push(<div className={'pageButton shortcut'} key={'page_last'} style={{ backgroundImage: 'url(images/paging/last.png)' }} onClick={handlePageClick} data-dest={pageCount}></div>)

        return DOM;
    };
    return (
        <div className={styles.grid}>
            {props.currentPageNo !== undefined && props.lastPageNo !== undefined && props.onPageChanged !== undefined ? (
                <div className={styles.pageList}>{generatePages(props.currentPageNo, props.lastPageNo)}</div>
            ) : null}
            {props.searchFilters && props.doSearch && <Search filters={props.searchFilters} doSearch={props.doSearch} type="footer" />}
        </div>
    );
};

export default Pagination;
